export default __webpack_public_path__ + "static/media/48-min.b151701f.png";